// extracted by mini-css-extract-plugin
module.exports = {"productChips":"ProductChipsLayout_productChips__z9M7u"};